"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const initCookieModal = ($cookieModal) => {
    const COOKIE_POLICY_PARAMS = {
        name: 'cookiesAccepted',
        types: {
            all: 'all',
            requiredOnly: 'required-only',
        },
    };
    if (getCookie(COOKIE_POLICY_PARAMS.name) &&
        [COOKIE_POLICY_PARAMS.types.all, COOKIE_POLICY_PARAMS.types.requiredOnly].includes(getCookie(COOKIE_POLICY_PARAMS.name))) {
        $cookieModal.remove();
        return;
    }
    else {
        $cookieModal.removeAttribute('hidden');
        $cookieModal.classList.add('visible');
    }
    setPageHeight();
    window.addEventListener('resize', setPageHeight);
    const flag = $cookieModal.querySelector('.j-cookie-flag');
    const showSwitchersBtn = $cookieModal.querySelector('.j-show-cookies');
    const hideSwitchersBtn = $cookieModal.querySelector('.j-hide-cookies');
    const acceptCookiesBtns = $cookieModal.querySelectorAll('.j-accept-cookies');
    showSwitchersBtn.addEventListener('click', () => {
        $cookieModal.classList.add('expanded');
    });
    hideSwitchersBtn.addEventListener('click', () => {
        $cookieModal.classList.remove('expanded');
    });
    acceptCookiesBtns.forEach(btn => {
        btn.addEventListener('click', () => __awaiter(void 0, void 0, void 0, function* () {
            const value = flag.checked ? COOKIE_POLICY_PARAMS.types.all : COOKIE_POLICY_PARAMS.types.requiredOnly;
            setCookie(COOKIE_POLICY_PARAMS.name, value, { 'max-age': 60 * 60 * 24 * 365 });
            $cookieModal.style.transition = 'opacity .4s';
            $cookieModal.style.opacity = '0';
            setTimeout(() => $cookieModal.remove(), 400);
        }));
    });
    function getCookie(name) {
        const matches = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')}=([^;]*)`));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }
    function setCookie(name, value, options = {}) {
        options = Object.assign({ path: '/' }, options);
        let updatedCookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        for (let optionKey in options) {
            updatedCookie += `; ${optionKey}`;
            const optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += `=${optionValue}`;
            }
        }
        document.cookie = updatedCookie;
    }
    function setPageHeight() {
        document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    }
};
exports.default = initCookieModal;
